<a class="hyperlink" href="javascript:void(0);" (click)="openModal()">{{organizationName}}</a>
